import { render, staticRenderFns } from "./survey_details.vue?vue&type=template&id=ab973466"
import script from "./survey_details.vue?vue&type=script&lang=js"
export * from "./survey_details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports